import { THEME } from "constants/types";


export const setTheme = (theme) => dispatch => {

	dispatch({
		type: THEME.SET_THEME,
		payload: theme
	})
}

export const setGlobalTheme = (theme) => dispatch => {

	dispatch({
		type: THEME.SET_GLOBAL_THEME,
		payload: theme
	})
}